
import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';

export default extend(dialog, {
    namespaced: true,
    state: {
        form: {},
        isEdit: false
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/ums/resource/add-edit-category-dialog.js